import React from 'react';

import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import useUserHook from 'hooks/useUserHook';

import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';
import GuardedRoute from 'components/common/GuardedRoute/guardedRoute';
import NoAccess from 'components/common/NoAccess/noAccess';
import { SideMenuListProps } from 'components/common/SideMenu/SideMenu';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { Responsive } from 'components/Dashboards/responsive';
import { PhasePerformanceManageAddTemplatePage } from 'components/pages/PhasePerformanceManageAddTemplatePage';
import { PhasePerformanceManageMapProjectPage } from 'components/pages/PhasePerformanceManageMapProjectPage';
import { PhasePerformanceManagePage } from 'components/pages/PhasePerformanceManagePage';
import { PhasePerformancePage } from 'components/pages/PhasePerformancePage';
import { PortfolioDataStoriesPage } from 'components/pages/PortfolioDataStoriesPage';
import { PortfolioOverviewPage } from 'components/pages/PortfolioOverviewPage';

export const sideMenu: SideMenuListProps[] = [
    {
        ...portfolioConfig.portfolioOverview,
        id: 'PortfolioOverview',
        muiIcon: <MuiIcon icon={'next_week'} fontSize="2.5rem" color="#9eadc1" />,
        permissions: 'PortfolioOverview',
    },
    {
        ...portfolioConfig.phasePerformance,
        id: 'PhasePerformance',
        muiIcon: <MuiIcon icon={'shutter_speed'} fontSize="2.5rem" color="#9eadc1" />,
        permissions: 'PhasePerformance',
    },
    {
        ...portfolioConfig.dataStories,
        id: 'DataStories',
        muiIcon: <MuiIcon icon={'feed'} fontSize="2.5rem" color="#9eadc1" />,
        permissions: 'DataStoryRead',
    },
];

export const PortfolioRoutes = () => {
    const { path } = useRouteMatch();
    const { ability } = useUserHook();
    const redirect = sideMenu.find((item) => {
        return item.permissions && ability.can('view', item.permissions);
    });
    const PhasePerformanceAbility = ability.can('view', 'PhasePerformance');
    return (
        <Responsive sideMenu={sideMenu} title={'Portfolio'}>
            <Switch>
                <GuardedRoute
                    path={`${path}/${portfolioConfig.dataStories.link}`}
                    component={PortfolioDataStoriesPage}
                    auth={ability.can('view', 'DataStoryRead')}
                    redirect={`${path}/no-access`}
                />
                <GuardedRoute
                    path={`${path}/${portfolioConfig.portfolioOverview.link}`}
                    component={PortfolioOverviewPage}
                    auth={ability.can('view', 'PortfolioOverview')}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageMapProject.link}`}
                    component={PhasePerformanceManageMapProjectPage}
                    auth={ability.can('view', 'PortfolioPage')}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageAddTemplate.link}`}
                    component={PhasePerformanceManageAddTemplatePage}
                    auth={PhasePerformanceAbility}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/${portfolioConfig.phasePerformanceManage.link}`}
                    component={PhasePerformanceManagePage}
                    auth={PhasePerformanceAbility}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/:templateId([0-9-]+)?`}
                    component={PhasePerformancePage}
                    auth={PhasePerformanceAbility}
                    redirect={`${path}/no-access`}
                />

                <Route exact path={`${path}/no-access`} component={NoAccess} />

                {/* default route */}
                <Route exact path={path} render={() => <Redirect to={`${path}/${redirect?.link}`} />} />
                <Route path="*" component={PageNotFound} />
            </Switch>
        </Responsive>
    );
};
